import { render } from "./AppHeaderDropdownMssgs.vue?vue&type=template&id=0b2337a8"
import script from "./AppHeaderDropdownMssgs.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownMssgs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__